<div class="info-container">
  <mat-icon>info</mat-icon>
  <div>
    <ng-content></ng-content>
  </div>
</div>
